export const data = [
    {
        message:"Don't forget to delegate wearable Bomber Pants by February 1st, 2021.",
        sentDate:"January 30th, 2021 at 12:00 AM",
        status:"on",
        footerLink:""
    },
    {
        message:"Don't forget to delegate wearable Bomber Pants by February 1st, 2021.",
        sentDate:"January 30th, 2021 at 12:00 AM",
        status:"on",
        footerLink:""
    },
    {
        message:"Don't forget to delegate wearable Bomber Pants by February 1st, 2021.",
        sentDate:"January 30th, 2021 at 12:00 AM",
        status:"on",
        footerLink:""
    },
    {
        message:"Don't forget to delegate wearable Bomber Pants by February 1st, 2021.",
        sentDate:"January 30th, 2021 at 12:00 AM",
        status:"off",
        footerLink:"Visit ICE Poker"
    },    {
        message:"Don't forget to delegate wearable Bomber Pants by February 1st, 2021.",
        sentDate:"January 30th, 2021 at 12:00 AM",
        status:"off",
        footerLink:""
    },    {
        message:"Don't forget to delegate wearable Bomber Pants by February 1st, 2021.",
        sentDate:"January 30th, 2021 at 12:00 AM",
        status:"off",
        footerLink:"Visit ICE Poker"
    },
]